export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7824.d032b90a.jpg";